import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("input", {
    class: _normalizeClass(["form-control", [_ctx.disabled ? 'disabled' : '', _ctx.inputClass]]),
    type: "text",
    ref: "inputRef",
    placeholder: _ctx.placeholder,
    onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onChanged && _ctx.onChanged(...args))),
    disabled: _ctx.disabled
  }, null, 42, _hoisted_1))
}